<div class="pr-2 pl-2 d-flex justify-content-between">
    <input type="text"  placeholder="Search ID, Name..." class="form-control col-lg-4 mt-1"
        (keyup)="updateFilter($event)"   />

</div>
<br>
<ngx-datatable class="material" [rows]="dataList" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
    [rowHeight]="'auto'" [scrollbarV]="false" [limit]="10" [sorts]="[{dir: 'desc'}]"
    style="position: relative !important;">
    <ngx-datatable-column [flexGrow]="1" name="ID" prop="categoryId">
        <ng-template let-row="row" ngx-datatable-cell-template>
            #{{row.autoId}}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="3" name="Name" prop="categoryname">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <span [title]="row.categoryname">{{row.name}}</span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [flexGrow]="3" name="image" prop="categoryimage">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <img style="border: #b0b0b0 solid 2px;width: 66px;height: 66px;" class="rounded-circle"
                [src]="getSanitizeUrl(row.trimImage)" />
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [flexGrow]="2" name="Date">
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.createdAt | date:'medium'}}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="1" name="Edit">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <a [routerLink]="['/admin/guidance-category/edit',row._id]"
                class="btn-table-custom btn btn-sm btn-outline-primary">Edit</a>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>